import React, { useEffect, useState } from "react";
import BasicInfoForm from "./BasicInfoForm";
import BillingProfile from "./BillingProfile";
import Identification from "./Identification";
import EmergencyContacts from "./EmergencyContacts";
import MedicalHistory from "./MedicalHistory";
import AllergiesMedications from "./AllergiesMedications";
import MeasuresVitals from "./MeasuresVitals";
import ConsentForms from "./ConsentForms";
import DocumentUpload from "./DocumentUpload";
import { useLocation } from "react-router-dom";
import { Getagencypatientdetails, GetappointmentsDetails, Patientrequestupdates } from "../../api/helper";

const VerifyRequiredForms = () => {
  const [selectedForm, setSelectedForm] = useState(null);
  const [appointmentData, setAppointmentData] = useState(null);
  const [patientData, setPatientData] = useState(null);
  const location = useLocation();
  const originalClient = location.state?.originalClient;
  // console.log(originalClient?.response?.patientIntake, "originalClient====")
  const [completedForms, setCompletedForms] = useState({
    "basic-info": false,
    payment: false,
    identification: false,
    "emergency-contacts": false,
    history: false,
    "allergy-meds": false,
    "measures-vitals": false,
    consents: false,
    "upload-docs": false,
  });
  const intakeLabelToKey = {
    "Basic Information": "basicinfo",
    "Billing Profile": "BillingProfile",
    "Identification": "identification",
    "Emergency Contacts": "emergencyContacts",
    "Medical History": "medicalHistory",
    "Allergies & Medications": "allergiesMedications",
    "Measures & Vitals": "measuresVitals",
    "Consent Forms": "consentForms",
    "Document Upload": "documentUpload",
  };

  const formItems = [
    { key: "basic-info", label: "Basic Information" },
    { key: "payment", label: "Billing Profile" },
    { key: "identification", label: "Identification" },
    { key: "emergency-contacts", label: "Emergency Contacts" },
    { key: "history", label: "Medical History" },
    { key: "allergy-meds", label: "Allergies & Medications" },
    { key: "measures-vitals", label: "Measures & Vitals" },
    { key: "consents", label: "Consent Forms" },
    { key: "upload-docs", label: "Document Upload" },
  ];

  const filteredFormItems = formItems.filter((item) =>
    originalClient?.response?.patientIntake?.includes(item.label)
  );
  const calculateProgress = () => {
    const intakeForm = patientData?.intackForm || {};
    const activeKeys = filteredFormItems.map((f) => intakeLabelToKey[f.label]);
    const filledCount = activeKeys.filter((key) => intakeForm[key]).length;
    const percent = (filledCount / activeKeys.length) * 100;
    return `${percent.toFixed(2)}%`;
  };

  const FetchAppointmentDetails = async () => {
    try {
      const res = await GetappointmentsDetails(originalClient?.response?._id);
      setAppointmentData(res?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    FetchAppointmentDetails();
  }, [originalClient]);

  useEffect(() => {
    if (!selectedForm && filteredFormItems.length > 0) {
      setSelectedForm(null);
    }
  }, [filteredFormItems]);

// console.log(appointmentData,"appointmentData====")

  const renderFormComponent = () => {
    const progressPercentage = parseFloat(calculateProgress());
    if (!selectedForm) {
      return (
        <>
          {progressPercentage === 100 ? (
            <>
              <article className="welcome-card">
                <h2 className="welcome-card__title">
                  Congratulations! You've completed all the forms.
                </h2>
                <p className="welcome-card__description">
                  You have successfully filled out all the necessary intake forms.
                  We look forward to seeing you at your appointment with
                  <strong> NAGELEY MICHEL DNP</strong> at EnnHealth - Telehealth on
                  <strong> {appointmentData?.date} at {appointmentData?.startTime}</strong>.
                </p>
              </article>
            </>
          ) : <>
            <article className="welcome-card">
              <h2 className="welcome-card__title">
                Welcome to EnnHealth
              </h2>
              <p className="welcome-card__description">
                Please complete your patient forms for your visit with{" "}
                <strong>NAGELEY MICHEL DNP</strong> at EnnHealth - Telehealth
                <br />
                on <strong>{appointmentData?.date} at {appointmentData?.startTime}</strong>.
                <br />
                <br />
                You'll save time in the waiting room and have a smoother visit.
              </p>
            </article>
            <button
              className="start-button"
              onClick={() => setSelectedForm("basic-info")}
            >
              Start with Basic Information
            </button>
          </>
          }
        </>
      );
    }
    const FormHeader = () => (
      <div className="form-header">
        <div className="form-header__content">
          <div>
            <h2 className="form-title">
              {filteredFormItems.find((f) => f.key === selectedForm)?.label} Form
            </h2>
            <p className="form-description">
              Complete all required fields marked with *
            </p>
          </div>
          <button
            onClick={() => setSelectedForm(null)}
            className="back-button"
          >
            ← Back to Overview
          </button>
        </div>
      </div>
    );
    const renderWithHeader = (Component, props) => (
      <div className="intake-content">
        <FormHeader />
        <Component {...props} />
      </div>
    );
    switch (selectedForm) {
      case "basic-info":
        return renderWithHeader(BasicInfoForm, {
          data: originalClient,
          onComplete: (status) => {
            setCompletedForms((prev) => ({ ...prev, "basic-info": status }));
            if (status) UpdateTabstatus("Basic Information");
          },
        });

      case "payment":
        return renderWithHeader(BillingProfile, {
          data: originalClient,
          appointmentdetail: appointmentData,
          onComplete: (status) => {
            setCompletedForms((prev) => ({ ...prev, payment: status }));
            if (status) UpdateTabstatus("Billing Profile");
          },
        });

      case "identification":
        return renderWithHeader(Identification, {
          data: originalClient,
          onComplete: (status) => {
            setCompletedForms((prev) => ({ ...prev, identification: status }));
            if (status) UpdateTabstatus("Identification");
          },
        });

      case "emergency-contacts":
        return renderWithHeader(EmergencyContacts, {
          data: originalClient,
          appointmentdetail: appointmentData,
          onComplete: (status) => {
            setCompletedForms((prev) => ({
              ...prev,
              "emergency-contacts": status,
            }));
            if (status) UpdateTabstatus("Emergency Contacts");
          },
        });

      case "history":
        return renderWithHeader(MedicalHistory, {
          data: originalClient,
          appointmentdetail: appointmentData,
          onComplete: (status) => {
            setCompletedForms((prev) => ({ ...prev, history: status }));
            if (status) UpdateTabstatus("Medical History");
          },
        });

      case "allergy-meds":
        return renderWithHeader(AllergiesMedications, {
          data: originalClient,
          appointmentdetail: appointmentData,
          onComplete: (status) => {
            setCompletedForms((prev) => ({
              ...prev,
              "allergy-meds": status,
            }));
            if (status) UpdateTabstatus("Allergies & Medications");
          },
        });

      case "measures-vitals":
        return renderWithHeader(MeasuresVitals, {
          onComplete: (status) => {
            setCompletedForms((prev) => ({
              ...prev,
              "measures-vitals": status,
            }));
            if (status) UpdateTabstatus("Measures & Vitals");
          },
        });

      case "consents":
        return renderWithHeader(ConsentForms, {
          data: originalClient,
          appointmentdetail: appointmentData,
          onComplete: (status) => {
            setCompletedForms((prev) => ({ ...prev, consents: status }));
            if (status) UpdateTabstatus("Consent Forms");
          },
        });

      case "upload-docs":
        return renderWithHeader(DocumentUpload, {
          data: originalClient,
          onComplete: (status) => {
            setCompletedForms((prev) => ({ ...prev, "upload-docs": status }));
            if (status) UpdateTabstatus("Document Upload");
          },
        });

      default:
        return null;
    }
  };

  const GetInfo = async () => {

    try {
      const response = await Getagencypatientdetails(
        originalClient?.response?.patientRequestId
      );
      const resData = response?.data?.data;
      // console.log(resData, "resData===GetInfo===")
      setPatientData(resData);
    } catch (error) {
      console.error("Failed to fetch patient details", error);
    }
  };
  useEffect(() => {
    GetInfo();
  }, []);

  const UpdateTabstatus = async (completedFormLabel) => {
    const intakeFormLabels = originalClient?.response?.patientIntake || [];
    const previousIntackForm = patientData?.intackForm || {};

    const intackForm = intakeFormLabels.reduce((acc, label) => {
      const key = intakeLabelToKey[label];
      if (key) {
        acc[key] = previousIntackForm[key] || (label === completedFormLabel);
      }
      return acc;
    }, {});

    const payload = {
      id: originalClient?.response?.patientRequestId,
      intackForm,
    };

    try {
      await Patientrequestupdates(payload);
      GetInfo();
    } catch (error) {
      console.error("UpdateTabstatus error:", error);
    }
  };

  // console.log(patientData?.intackForm, "patientData?.intackForm===")

  return (
    <div className="intake-wrapper">
      <div className="intake-container">
        <aside className="intake-sidebar">
          <div className="scrollable-content">
            <div className="sidebar-header" style={{ textAlign: "left" }}>
              <h2 style={{ color: "white" }}>Patient Intake Forms</h2>
              <p>Click on each form to complete</p>
            </div>

            <div className="sidebar-forms">
              {filteredFormItems.map((item) => {
                const isActive = selectedForm === item.key;
                const keyFromLabel = intakeLabelToKey[item.label];
                const isCompleted = patientData?.intackForm?.[keyFromLabel];

                return (
                  <button
                    key={item.key}
                    className={`form-button ${isCompleted ? "completed" : ""} ${isActive ? "active" : ""}`}
                    onClick={() => setSelectedForm(item.key)}
                  >
                    <span>{item.label}</span>
                  </button>
                );
              })}

              <div className="sidebar-progress">
                <div className="progress-labels">
                  <span>Progress</span>
                  <span>{calculateProgress()}</span>
                </div>
                <div className="progress-bar-container">
                  <div
                    className="progress-bar-fill"
                    style={{ width: calculateProgress() }}
                  />
                </div>
                <p>
                  {
                    filteredFormItems.filter((item) =>
                      patientData?.intackForm?.[intakeLabelToKey[item.label]]
                    ).length
                  }{" "}
                  of {filteredFormItems.length} forms completed
                </p>
              </div>
            </div>
          </div>
        </aside>
        <main className="intake-content">{renderFormComponent()}</main>
      </div>
    </div>
  );
};

export default VerifyRequiredForms;
